export default __webpack_public_path__ + "static/media/person.ef4c9318.png";